// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://csxyxipkxrmdaazayhyg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNzeHl4aXBreHJtZGFhemF5aHlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM3NDY4NzQsImV4cCI6MjA3OTMyMjg3NH0.fg1n6OfEKDEEWACRi033dq3Pgc4nSFF8qtr3UxIgKVA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});